import React from "react";
import LinkifyText from "../LinkifyText";

const SIZE_MAP = {
  small: "0.85em",
  normal: "1em",
  large: "1.15em",
  xlarge: "1.35em",
};

const urlRegex =
  /(http:\/\/[^\s]+|https:\/\/[^\s]+|www\.[^\s]+|[^\s]+\.[a-z]{2,})/gi;

const linkifySegment = (text, keyBase) => {
  if (!text) return null;
  return text.split(/(\s+)/).map((part, i) => {
    if (urlRegex.test(part)) {
      const url = part.startsWith("http") ? part : `http://${part}`;
      return (
        <a
          key={`${keyBase}-l-${i}`}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          {part}
        </a>
      );
    }
    return <React.Fragment key={`${keyBase}-t-${i}`}>{part}</React.Fragment>;
  });
};

const sameSet = (a, b) => {
  const ak = Object.keys(a);
  const bk = Object.keys(b);
  if (ak.length !== bk.length) return false;
  for (const k of ak) if (a[k] !== b[k]) return false;
  return true;
};

const wrapRun = (text, set, key) => {
  const inlineStyle = {};
  if (set.c) inlineStyle.color = set.c;
  if (set.sz && SIZE_MAP[set.sz]) inlineStyle.fontSize = SIZE_MAP[set.sz];

  let node = linkifySegment(text, key);
  if (Object.keys(inlineStyle).length > 0) {
    node = (
      <span key={`${key}-css`} style={inlineStyle}>
        {node}
      </span>
    );
  }
  if (set.s) node = <s key={`${key}-s`}>{node}</s>;
  if (set.u) node = <u key={`${key}-u`}>{node}</u>;
  if (set.i) node = <em key={`${key}-i`}>{node}</em>;
  if (set.b) node = <strong key={`${key}-b`}>{node}</strong>;
  return <React.Fragment key={key}>{node}</React.Fragment>;
};

const RichText = ({ text, styles, isSelf, isFile, file, isUndo }) => {
  if (!text || isUndo || isFile || !styles || styles.length === 0) {
    return (
      <LinkifyText
        text={text}
        isFile={isFile}
        file={file}
        isUndo={isUndo}
        isSelf={isSelf}
      />
    );
  }

  const len = text.length;
  const active = Array.from({ length: len }, () => ({}));
  for (const s of styles) {
    const start = Math.max(0, s.start | 0);
    const end = Math.min(len, start + (s.len | 0));
    for (let i = start; i < end; i++) {
      active[i][s.st] = s.v != null ? s.v : true;
    }
  }

  const runs = [];
  if (len > 0) {
    let cur = { from: 0, set: active[0] };
    for (let i = 1; i <= len; i++) {
      if (i === len || !sameSet(active[i], cur.set)) {
        runs.push({ from: cur.from, to: i, set: cur.set });
        if (i < len) cur = { from: i, set: active[i] };
      }
    }
  }

  return (
    <p>
      {runs.map((r, k) =>
        wrapRun(text.slice(r.from, r.to), r.set, `run-${k}`),
      )}
    </p>
  );
};

export default RichText;
